export const CATEGORY_MAPPING = {
    'Crates Gates and Containment': 'Crates, Gates & Containment',
    'Collars Harnesses and Leashes': 'Collars, Harnesses & Leashes',
    'Bandanas Bows and Hats': 'Bandanas, Bows & Hats',
    'Boots Shoes and Socks': 'Boots, Shoes & Socks',
    'T shirts and Tank Tops': 'T-shirts & Tank Tops',
    'Training Collars Leashes and Harnesses':
        'Training Collars, Leashes & Harnesses',
    'Eye Ear Nose and Paw Care': 'Eye, Ear, Nose & Paw Care',
    'Brushes Combs and Blowdryers': 'Brushes, Combs & Blowdryers',
    'Biscuits Cookies and Bakery Treats': 'Biscuits, Cookies & Bakery Treats',
    'Bones Bully Sticks and Chews': 'Bones, Bully Sticks & Chews',
    'Plush Balls and Mice': 'Plush, Balls & Mice',
    'Tunnels Tents and Sacks': 'Tunnels, Tents & Sacks',
    'Decor Gravel and Substrate': 'Decor, Gravel & Substrate',
    'Tanks Aquariums and Nets': 'Tanks, Aquariums & Nets',
    'Gravel Sand and Stones': 'Gravel, Sand & Stones',
    'Goldfish Betta and More': 'Goldfish, Betta & More',
    'Toys Perches and Decor': 'Toys, Perches & Decor',
    'Conure Parakeets and More': 'Conure, Parakeets & More',
    'Snakes Turtles and More': 'Snakes, Turtles & More',
    'Cages Habitats and Hutches': 'Cages, Habitats & Hutches',
    'Food Treats and Hay': 'Food, Treats & Hay',
    'Hamsters Guinea Pigs and More': 'Hamsters, Guinea Pigs & More',
    'Digestive Tract Liver and Pancreas': 'Digestive Tract, Liver & Pancreas',
};

export const getMappedCategoryName = (category: string) => {
    const mappedCategory =
        CATEGORY_MAPPING[category as keyof typeof CATEGORY_MAPPING];
    return mappedCategory ?? category;
};
